import { module } from 'modujs'

export default class extends module {
  constructor(m) {
    super(m)

    this.video = this.el.querySelector('video')
    this.isLoaded = false
    this.onMouseEnter = this.onMouseEnter.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
    this.onCanPlayThrough = this.onCanPlayThrough.bind(this)

    if (this.video) {
      const source = this.video.querySelector('source[data-src]')

      if (source) {
        source.setAttribute('src', source.getAttribute('data-src'))
        source.removeAttribute('data-src')
        this.video.addEventListener(
          'canplaythrough',
          this.onCanPlayThrough,
          { once: true }
        )
        this.video.load()
      }

      this.el.addEventListener('mouseenter', this.onMouseEnter)
      this.el.addEventListener('mouseleave', this.onMouseLeave)
    }
  }

  onCanPlayThrough() {
    this.isLoaded = true
    this.loaded()
  }

  onMouseEnter() {
    if (this.isLoaded) {
      this.video.play()
    }
  }

  onMouseLeave() {
    if (this.isLoaded) {
      this.video.pause()
    }
  }

  loaded() {
    this.video?.parentNode.classList.add('-loaded')
  }

  destroy() {
    this.video?.removeEventListener('canplaythrough', this.onCanPlayThrough)

    this.el.removeEventListener('mouseenter', this.onMouseEnter)
    this.el.removeEventListener('mouseleave', this.onMouseLeave)
  }
}
